import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-32 px-6 bg-charcoal relative border-t border-gold/20 overflow-hidden" data-id="element-66">
      {/* Intense background glow for final impact */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-gold-muted rounded-full blur-[200px] opacity-20 pointer-events-none" data-id="element-67" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-68">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-playfair text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-12" data-id="element-69">
          LIBERA TU PODER <span className="text-gold italic" data-id="element-70">AHORA</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-71">
          <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="group relative inline-block px-14 py-7 btn-metallic-gold text-charcoal font-sans font-bold text-xl tracking-widest rounded-sm overflow-hidden transition-all hover:shadow-gold-glow-lg hover:scale-105 duration-300 text-center" data-id="element-72">
            <div className="absolute inset-0 w-full h-full bg-white/25 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-73" />
            <span className="relative z-10" data-id="element-74">QUIERO MI CÓDIGO</span>
          </a>

          <p className="mt-8 font-sans text-gray-500 text-sm tracking-widest uppercase flex items-center justify-center gap-4" data-id="element-75">
            <span className="w-8 h-[1px] bg-gray-600" data-id="element-76" />
            Tu nueva vida comienza hoy
            <span className="w-8 h-[1px] bg-gray-600" data-id="element-77" />
          </p>
        </motion.div>
      </div>
    </section>;
}